import { attempt } from "@omni/utils/function.utils";
import { get } from "@omni/utils/object.utils";

import { ProductConfiguration } from "./productConfiguration/productConfiguration.types";

export const getProductConfigurationPreview = (
    configuration?: Record<string, unknown>,
    productConfiguration?: ProductConfiguration
) => {
    return attempt(() => {
        const previewValue = get(
            configuration!,
            productConfiguration!.previewPath!
        );
        return previewValue ? `(${previewValue})` : "";
    }, "");
};
